import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';

@Component({
    selector: 'app-settings-widget',
    templateUrl: './settings-widget.component.html',
    styleUrls: ['../base-widget/base-widget.component.scss', './settings-widget.component.scss'],
    standalone: false
})
export class SettingsWidgetComponent extends BaseWidgetComponent {
  @Input() initialTab: 'setup' | 'system' | 'theme' | 'display' | 'gpus' | 'labs' | null = null;

  @Output() onStartChat = new EventEmitter<void>();

  handleStartChat(): void {
    this.onStartChat.emit();
    this.close();
  }
}
